import { render, staticRenderFns } from "./CertificateScanned.vue?vue&type=template&id=40371b67"
import script from "./CertificateScanned.vue?vue&type=script&lang=js"
export * from "./CertificateScanned.vue?vue&type=script&lang=js"
import style0 from "./CertificateScanned.vue?vue&type=style&index=0&id=40371b67&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports